// extracted by mini-css-extract-plugin
module.exports = {"title":"widgets_title__ucY4G","img":"widgets_img__KYkO7","staticImagesContainer":"widgets_staticImagesContainer__1SsLm"};